export const WORKSPACE_PRODUCTS = [
  {
    id: 'newsletter',
    label: 'Newsletter',
    description: 'Broadcast updates to selected contacts from the sidebar.',
    href: '/apps/newsletter',
  },
];

export function isWorkspaceProductId(value) {
  return WORKSPACE_PRODUCTS.some((product) => product.id === value);
}

export function hasProduct(enabledProducts, productId) {
  return Boolean(enabledProducts?.includes(productId));
}

export function getProduct(productId) {
  return WORKSPACE_PRODUCTS.find((product) => product.id === productId);
}
